// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { DiscoveryContentTypeOriginSchema } from '../inputTypeSchemas/DiscoveryContentTypeOriginSchema'

/////////////////////////////////////////
// DISCOVERY CONTENT TYPE CONFIG SCHEMA
/////////////////////////////////////////

export const DiscoveryContentTypeConfigSchema = z.object({
  origin: DiscoveryContentTypeOriginSchema,
  mimeType: z.string(),
  description: z.string().nullable(),
  crawlerEnabled: z.boolean(),
  torchTrackingEnabled: z.boolean(),
})

export type DiscoveryContentTypeConfig = z.infer<typeof DiscoveryContentTypeConfigSchema>

export default DiscoveryContentTypeConfigSchema;
